import request from '@/utils/require'

/**
 * 新闻列表
 */
export function getNewsList(query) {
  return request({
    url: '/unify/newsListV2',
    method: 'get',
    params: query
  })
}

/**
 * 新闻列表id查询
 */
export function getNewsDefault(id) {
  return request({
    url: '/unify/news/'+ id,
    method: 'get',
  })
}